<template>
	<div>
		<a-row>
			<a-row class="banner-title">
				<a-col :span="20"><h3>商会公告</h3></a-col>
				<a-col :span="4" style="padding-bottom: 15px;"><a-button type="danger" icon="plus-square" @click="showAddStyleModal">发布公告</a-button></a-col>
			</a-row>
			<!-- <span :key="index" v-for="(item,index) in informList">	
					<a-card :title="item.title" style="width: 300px;float: left;margin-left: 10px;">
						<a slot="extra" @click="deleteInform(item.id)" href="#">删除</a>
						<p>{{item.content}}</p>
					</a-card>
				</span> -->
		</a-row>

		<a-list style="width: 1000px;" item-layout="vertical" size="large" :pagination="pagination" :data-source="informList">
			<div slot="footer">
				<b>帝全</b>
				商会公告
			</div>
			<a-list-item slot="renderItem" :key="item.title" slot-scope="item, index">
				<!-- <template slot="actions">
	           <a-icon :type="type" style="margin-right: 8px" />
	          {{ text }} 
			  <a slot="extra" @click="deleteInform(item.id)" href="#">删除</a>
			  <span>{{item.addTime}}</span>
	      </template> -->

				<template slot="actions">
					<a-popconfirm title="将删除该条商会公告,是否删除？" @confirm="deleteInform(item.id)" @cancel="cancel" okText="删除" cancelText="取消">
						<a-button type="danger" size="small">删除</a-button>
					</a-popconfirm>
					<span>{{ item.addTime }}</span>
				</template>

				<!-- <img
	        slot="extra"
	        width="272"
	        alt="logo"
	        src="https://gw.alipayobjects.com/zos/rmsportal/mqaQswcyDLcXyDKnZfES.png"
	      /> -->
				<a-list-item-meta description="">
					<a slot="title">{{ item.title }}</a>
					<a-avatar slot="avatar" src="http://cdn.diqwl.com/store_banner_inform3.png" />
				</a-list-item-meta>
				{{ item.content }}
			</a-list-item>
		</a-list>

		<a-modal width="840px" :title="menu" :visible="addCompanyStyleWindow" :confirmLoading="addCompanyStyleLoading" @cancel="addCompanyStyleCancel" footer="">
			<a-form :form="form">
				<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="商会公告标题">
					<a-input v-decorator="['title', { rules: [{ required: true, message: '请输入商会公告标题' }] }]" placeholder="请输入商会公告标题" />
				</a-form-item>
				<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 15 }" label="商会公告内容">
					<a-textarea v-decorator="['content', { rules: [{ required: true, message: '请输入商会公告内容' }] }]" placeholder="请输入商会公告内容" :rows="7" />
				</a-form-item>

				<a-form-item :wrapper-col="{ span: 12, offset: 5 }"><a-button type="primary" @click="handleSubmit">保存</a-button></a-form-item>
			</a-form>
		</a-modal>
	</div>
</template>

<script>
import E from 'wangeditor';
import api from '../../api/Api.js';
export default {
	name: 'WriteArticle',
	data() {
		return {
			Title: '',
			Content: '',
			menu: '商会公告',
			addCompanyStyleWindow: false,
			addCompanyStyleLoading: false,
			form: this.$form.createForm(this, { name: 'dynamic_rule' }),
			page: 0,
			informList: [],
			pagination: {
				onChange: page => {
					console.log(page);
				},
				pageSize: 5
			}
		};
	},
	mounted() {
		this.getInformList();
	},
	methods: {
		handleSubmit() {
			const that = this;

			this.$confirm({
				title: '确定保存吗？',
				content: '点击保存之后，您的数据将会即刻更改，谨慎操作！',
				onOk() {
					that.form.validateFields((err, values) => {
						if (!err) {
							that.data = {
								title: values.title,
								content: values.content
							};
							that.addInform();
						}

						return new Promise((resolve, reject) => {
							setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
						}).catch(() => console.log('Oops errors!'));
					});
				},
				onCancel() {
					that.$message.warning('你点击了取消');
				}
			});
		},
		addInform() {
			var that = this;

			let url = '/api/commerce/v1/admin/addInform';
			let parm = this.data;

			api.postRequest(url, parm, res => {
				const rest = res.data;
				if (rest.status == 200) {
					that.addCompanyStyleWindow = false;
					that.getInformList();
					that.resetForm();
					this.$message.success('添加成功！');
				} else {
					this.$message.error('服务器内部错误！');
				}
			});
		},
		getInformList() {
			const that = this;
			let url = 'api/commerce/v1/admin/InformList';
			let parm = {
				page: this.page
			};

			api.postRequest(url, parm, res => {
				console.log(res);

				const rest = res.data;
				if (rest.status == 200) {
					that.informList = rest.data;
					console.log('=====================');
					console.log(that.informList);
					console.log('=====================');
				} else {
					this.$message.error('服务器内部错误！');
				}
			});
		},
		resetForm() {
			this.form.resetFields();
		},
		showAddStyleModal() {
			this.addCompanyStyleWindow = true;
		},
		showCommodityModal(item) {
			this.addCompanyStyleWindow = true;
		},
		addCompanyStyleCancel() {
			this.addCompanyStyleWindow = false;
		},
		deleteInform(id) {
			const that = this;
			let url = 'api/commerce/v1/admin/deleteInform';
			let parm = {
				id: id
			};
			api.postRequest(url, parm, res => {
				const rest = res.data;
				if (rest.status == 200) {
					this.$message.success('删除成功！');
					that.getInformList();
				} else {
					this.$message.error('服务器内部错误！');
				}
			});
		},
		cancel() {
			console.log('取消');
		}
	}
};
</script>

<style>
.banner-title {
	border-bottom: 2px solid gray;
	margin-bottom: 30px;
	margin-top: 10px;
}
.preview_phone {
	width: 670px;
	height: 670px;
	background-image: url('../../static/phone.png');
	background-size: 100%;
}
</style>
